import React, { FC } from 'react';
import { CONSTANTS } from 'config/constants';
import RadioBtnTypeSetting from 'components/property-settings/radio-btn-type-setting/radio-btn-type-setting';
import { useTranslation } from 'react-i18next';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type ImplantStepsProps = {
    handleSettings: (propertyName: string, settingValue: string) => void;
    implantSteps: string;
    isRequired?: boolean;
    options?: string[];
};

const ImplantSteps: FC<ImplantStepsProps> = ({
    handleSettings,
    implantSteps,
    isRequired,
    options,
}: ImplantStepsProps) => {
    const { t: translate } = useTranslation(['construction-props']);

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('IMPLANT_STEPS')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <RadioBtnTypeSetting
                setting={options ? options : CONSTANTS.IMPLANT_STEPS}
                propertyName="implantSteps"
                settingValue={implantSteps?.split('IMPLANT_STEPS_')[1]}
                handlePropertySelection={handleSettings}
            />
        </PropertyBox>
    );
};

export default ImplantSteps;
